export default function initListViewToggle() {
  const isPresent = document.querySelector("[data-toggle-list-view]");
  if (!isPresent) {
    return;
  }

  // Select all buttons with the data-toggle-list-view attribute
  const toggleButtons = document.querySelectorAll("[data-toggle-list-view]");

  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      // Toggle the 'list-view-active' class on the body
      document.body.classList.toggle("list-view-active");

      // Toggle the 'active' class on the button itself
      button.classList.toggle("active");
    });
  });
}
